import { Outlet } from 'react-router';
import { RequireAccess } from '../guards';
import { ErrorBoundary } from '../ErrorBoundary';
import { useCurrentRoute, usePageAnnouncements } from '../route-meta';

/** Printable pages (legacy print_all_bug_page.php): no navigation chrome, white background. */
export function PrintLayout() {
  const current = useCurrentRoute();
  usePageAnnouncements(current?.title);
  return (
    <RequireAccess access="user">
      <main id="main" className="min-h-dvh bg-surface p-4 print:p-0">
        <h1
          id="page-title"
          tabIndex={-1}
          className="mb-3 text-2xl font-light text-heading outline-none"
        >
          {current?.title}
        </h1>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </RequireAccess>
  );
}
